import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { getStore } from './store';
import UserAgentProvider from 'features/user-agent/userAgent';
import ThemeProvider from 'features/theme/theme';
import { WebsocketProvider } from 'features/hub/hub';
import { DataProvider } from 'api/dataProvider';
import { AudioPlayerProvider } from 'features/audio/audio';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { isNativeAppWebview } from 'lib/useragents';

ReactGA.initialize(import.meta.env.VITE_GA4_ID);

// Remove console logs on production
if (import.meta.env.VITE_ENV_NAME === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const shouldLoadRecaptcha = window === window.parent && !isNativeAppWebview();

const appTree = (
  <DataProvider>
    <UserAgentProvider>
      <WebsocketProvider>
        <AudioPlayerProvider>
          <ThemeProvider>
            <Router>
              <App />
            </Router>
          </ThemeProvider>
        </AudioPlayerProvider>
      </WebsocketProvider>
    </UserAgentProvider>
  </DataProvider>
);

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={getStore()}>
      {shouldLoadRecaptcha ? (
        <GoogleReCaptchaProvider
          reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
        >
          {appTree}
        </GoogleReCaptchaProvider>
      ) : (
        appTree
      )}
    </Provider>
  </React.StrictMode>
);
